import { Button, Input, message, Typography } from 'antd';
import React, { useEffect, useState } from 'react'
import LilyButton from '../../components/button/lily-button';
import { ADD_COMMENT_TO_CLAIM_URL } from '../../api/URLs';
import portalAPI from '../../api/api';
import moment from 'moment';
import { PlusOutlined } from '@ant-design/icons';

const CommentsSection = (props) => {
    const { caseNumber, patientName, record } = props
    const { TextArea } = Input;
    const { Title } = Typography;
    const [isLoading, setIsLoading] = useState(false);
    const [comments, setComments] = useState([...record]);
    const [isComment, setIsComment] = useState(false);
    const [commentChanges, setCommentChanges] = useState("");

    const handleSaveComment = async () => {
        setIsLoading(true);
        try {
            if (!caseNumber || caseNumber === '') {
                message.error("Claim ID is required");
                return false
            };

            if (!patientName || patientName === '') {
                message.error("Claim ID is required");
                return false
            };

            let body = {
                text: commentChanges || '',
                as: 'patient',
                patientName: patientName || '',
                createdAt: moment(),
            };

            let URL = ADD_COMMENT_TO_CLAIM_URL.replace(":id", caseNumber);
            let rsp = await portalAPI.put(URL, body);
            if (rsp.data.status === 200) {
                setCommentChanges('');
                setIsComment(false);
                setComments((prev) => [
                    ...prev,
                    body
                ])
            }
        } catch (error) {
            message.error(`Failed to comment.`);
        } finally {
            setIsLoading(false);
        }
    }

    return (
        <div>
            <div className='d-flex flex-row align-items-center justify-content-between'>
                <Title className='m-0' level={5} style={{ fontWeight: '500' }}>
                    Comments
                </Title>
                {
                    !isComment && (
                        <Button icon={<PlusOutlined />} onClick={() => setIsComment(true)}>Add a comment</Button>
                    )
                }
            </div>
            <div style={styles.chatContainer}>
                {
                    isComment && (
                        <div className='d-flex flex-column gap-2'>
                            <TextArea value={commentChanges} onChange={(e) => setCommentChanges(e.target.value)} />
                            <div className='d-flex flex-row gap-2'>
                                <LilyButton loading={isLoading} onClick={handleSaveComment} text="Save" style={{ borderRadius: '5px' }} />
                                <Button onClick={() => setIsComment(false)}>Cancel</Button>
                            </div>
                        </div>
                    )
                }
                {[...comments]
                    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)) // Sort by createdAt descending
                    .map((msg, index) => {
                        const isPatient = msg.as === "patient";
                        return (
                            <div
                                key={index}
                                style={{
                                    ...styles.messageRow,
                                    justifyContent: isPatient ? "flex-start" : "flex-end",
                                }}
                            >
                                <div
                                    style={{
                                        ...styles.messageBubble,
                                        backgroundColor: isPatient ? "#e0f7fa" : "#dcedc8",
                                        alignSelf: isPatient ? "flex-start" : "flex-end",
                                    }}
                                >
                                    <div className='d-flex flex-row align-items-center gap-2'>
                                        <div style={styles.name}>
                                            {isPatient ? msg.patientName : "Processor"}
                                        </div>
                                        <div style={styles.timestamp}>
                                            {msg.createdAt && moment(msg.createdAt).format("MM/DD/YYYY | hh:mma")}
                                        </div>
                                    </div>
                                    <div>{msg.text}</div>
                                </div>
                            </div>
                        );
                    })}
                {/* {comments.map((msg, index) => {
                    const isPatient = msg.as === "patient";
                    return (
                        <div
                            key={index}
                            style={{
                                ...styles.messageRow,
                                justifyContent: isPatient ? "flex-start" : "flex-end",
                            }}
                        >
                            <div
                                style={{
                                    ...styles.messageBubble,
                                    backgroundColor: isPatient ? "#e0f7fa" : "#dcedc8",
                                    alignSelf: isPatient ? "flex-start" : "flex-end",
                                }}
                            >
                                <div className='d-flex flex-row align-items-center gap-2'>
                                    <div style={styles.name}>{isPatient ? msg.patientName : "Processor"}</div>
                                    <div style={styles.timestamp}>{msg.createdAt && moment(msg.createdAt).format("MM/DD/YYYY | hh:mma")}</div>
                                </div>
                                <div>{msg.text}</div>
                            </div>
                        </div>
                    );
                })} */}
            </div>
        </div>
    )
}

const styles = {
    chatContainer: {
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        padding: "20px",
        width: "100%",
        maxWidth: "600px",
        margin: "auto",
    },
    messageRow: {
        display: "flex",
    },
    messageBubble: {
        width: '100%',
        padding: "10px 15px",
        borderRadius: "12px",
        boxShadow: "0 1px 4px rgba(0, 0, 0, 0.1)",
        display: 'flex',
        flexDirection: 'column',
        gap: '5px'
    },
    name: {
        fontWeight: "bold",
        fontSize: "14px",
    },
    timestamp: {
        fontSize: "12px",
        color: "#888",
        textAlign: "right",
    },
};


export default CommentsSection